module.exports = __webpack_public_path__ + "img/photo3.091080f2.png";